import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { Group } from "src/app/shared/models/group.model";
import Swal from "sweetalert2";
import { AdminService } from "../../admin/admin-service";

@Component({
  selector: "app-group-members",
  templateUrl: "./group-members.component.html",
  styleUrls: ["./group-members.component.scss"],
})
export class GroupMembersComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  @Input() group: Group;
  member_status: boolean;
  members_list: any;
  translate: any;
  sure: string;
  please: string;
  deleted: string;
  cancel: string;
  description: any;
  approved_members_list: any;
  constructor(private service: AdminService) {}
  ngOnInit(): void {
    if (this.group) {
      this.memberList(this.group.id);
      this.approvedMember(this.group.id);
    }
  }
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => sub.unsubscribe());
    }
  }

  memberList(param) {
    this.member_status = false;
    this.subs.push(
      this.service.memberByProfile(param).subscribe((response) => {
        this.members_list = response.data;

        if (this.members_list) {
          this.member_status = true;
        }
      })
    );
  }

  approvedMember(param) {
    this.subs.push(
      this.service.groupMembersApproval(param).subscribe((response) => {
        this.approved_members_list = response.data;

        if (this.approved_members_list) {
        }
      })
    );
  }
}
